module.exports = __webpack_public_path__ + "./images/etrf.9387f8.jpg";